// extracted by mini-css-extract-plugin
module.exports = {"resultImage":"qOs4w1IO","selected":"_1TwPGae1","selectedDiv":"_1TNU3FlJ","container":"_1EUHvq-n","mainContainer":"_2ujHf-FO","hideContainer":"_3X7jvUyX","topOverlay":"_1PrK83f9","topOverlaySelected":"_1H68tezf","bottomOverlay":"_2av83vVU","bottomOverlaySelected":"_2Iw7YxtY","voteContainer":"_3SyjInqZ","nahButton":"_15BzHyf2","numberOverlay":"KZbYmudS"};
    if(module.hot) {
      // 1754515042971
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  